import React from 'react';

export default function LoadingSpinner () {
	return (
		<div className="d-flex justify-content-center align-items-center vh-100">
			<div className="spinner-grow text-primary" role="status"></div>
		</div>
	)
}